export const COOKIE_ACCEPTANCE = 'cookie_acceptance'
export const CUSTOMER = 'customer'
export const GATSBY_ROUTER = 'gatsby-router'
